import {
  RoleListFilterPanel,
  RoleListTablePanel,
} from "#src/batteries-included-components/Panels";
import { useStorageKey } from "#src/hooks/useStorageKey";
import React from "react";

export const RoleListTab = () => {
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      "roles"
    );

  return (
    <>
      <RoleListFilterPanel filterConfigStorageKey={filterConfigStorageKey} />
      <RoleListTablePanel
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
        filterConfigStorageKey={filterConfigStorageKey}
      />
    </>
  );
};
